










import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class TextHighlighter extends Vue {
  @Prop() text: string;

  @Prop() keywords?: string; // 关键词列表，逗号分隔

  get keywordList() {
    return this.keywords?.split(',')?.map((keyword: string) => keyword.trim());
  }

  get highlightedText() {
    let result = this.text;
    console.log('keywords', this.keywords);
    this.keywordList?.forEach((keyword: string) => {
      const regex = new RegExp(keyword, 'gi');
      result = result.replace(regex, `<span class="highlight">${keyword}</span>`);
    });
    return result;
  }
}
